import { Answer, EQuestionType } from '#models/questionnaire';
import { useFieldAnswer, useFieldStyles } from '#modules/LeadGeneration/hooks/field';
import { TextField as MatTextField, Typography } from '@material-ui/core';
import * as React from 'react';
import { isEmail } from '../utils';

interface TextFieldProps {
  answer: Answer;
  multiline?: boolean;
  disabled?: boolean;
  defaultValue?: string;
  questionId: string;
  type: EQuestionType;
  onChangeAnswer: (answer: Answer) => void;
}

export const FieldAnswer = ({
  answer,
  multiline = false,
  disabled = false,
  questionId,
  type,
  onChangeAnswer
}: TextFieldProps) => {
  const [formField, { touched, error }, { setError }] = useFieldAnswer({ answer, type, questionId });
  const { textField } = useFieldStyles();
  const { required, validate } = answer;

  const { value } = formField;

  React.useEffect(() => {
    onChangeAnswer(answer);
  }, [value]);

  React.useEffect(() => {
    if (error) {
      return;
    }
    let _error = undefined;
    if (required && !value) {
      _error = 'This is a required field';
    }
    if (validate) {
      if (!value) {
        _error = 'This is a required field';
      } else if (!isEmail(value) && type === EQuestionType.Email) {
        _error = 'Invalid email format';
      }
    }
    if (error !== _error) {
      setError(_error);
    }
  }, [value, answer]);

  return (
    <React.Fragment>
      <MatTextField
        {...formField}
        value={value || ''}
        className={textField}
        placeholder={answer.text}
        fullWidth
        variant='outlined'
        error={Boolean(error && touched)}
        multiline={multiline}
        size='small'
        disabled={disabled}
        InputProps={{
          className: 'lead-input swyft-input'
        }}
      />
      {error && touched && (
        <Typography variant='subtitle2' color='error'>
          {error}
        </Typography>
      )}
    </React.Fragment>
  );
};
